import React from "react";
import "./Loader.scss";

const Loader = () => {
  return (
    <div className="loader"></div>
  );
};

export default Loader;
